var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0406 7.04046L8.81828 7.05928V0.959364C8.81828 0.427866 8.39042 0 7.85892 0C7.32759 0 6.89955 0.427866 6.89955 0.959364L6.91836 7.04064H0.959364C0.427866 7.04064 0 7.4685 0 8C0 8.53133 0.427866 8.95919 0.959364 8.95919H6.90896V15.0406C6.90896 15.5718 7.33683 16 7.86832 16C8.39982 16 8.82769 15.5718 8.82769 15.0406V8.95936H15.0406C15.5721 8.95936 16 8.53116 16 8C16 7.46833 15.5673 7.04046 15.0406 7.04046Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPlus);
export default __webpack_public_path__ + "static/media/chat_plus.dc30bbdfb98132d2bf4ce64078703033.svg";
export { ForwardRef as ReactComponent };